const removeTabIndex = (id: string) => {
  const modalDOM = document.querySelector(`#${id}>[tabindex='-1']`);

  if (modalDOM) {
    modalDOM?.removeAttribute("tabindex");
  }
};

export default removeTabIndex;
